import { render } from "./QueueView.vue?vue&type=template&id=35f12ef4&scoped=true&ts=true"
import script from "./QueueView.vue?vue&type=script&lang=ts"
export * from "./QueueView.vue?vue&type=script&lang=ts"

import "./QueueView.vue?vue&type=style&index=0&id=35f12ef4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f12ef4"]])

export default __exports__